(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-gift-deadline"] && !Shopify.designMode) return;
  try {
    
  /* "Choose two" picks the Two chip under the price; the shared [data-nx-to-buy] handler scrolls to the form. */
  if (!window.__nxPick) {
    window.__nxPick = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nx-pick]');
      if (!b) return;
      var chip = document.querySelector('[data-nx-chip="' + b.getAttribute('data-nx-pick') + '"]');
      if (chip && chip.getAttribute('aria-checked') !== 'true') chip.click();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-meta-scents"] && !Shopify.designMode) return;
  try {
    
  /* "Add a refill set": the hero's own refill button does the choosing and the adding, so the scents band presses it. */
  if (!window.__nxScentsAdd) {
    window.__nxScentsAdd = true;
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nx-scents-add]')) return;
      var b = document.querySelector('[data-nx-refill-add]');
      if (b) b.click();
    });
  }
  /* The row turns on its own every 5 s while half of it is on screen, and stops for good once the reader touches it.
     Reduced motion, or a laptop where all three stand side by side, means it never turns. */
  document.querySelectorAll('[data-nx-scents]').forEach(function (root) {
    if (root.__nxScents) return;
    root.__nxScents = true;
    var track = root.querySelector('[data-nx-scents-track]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-nx-scents-card]'));
    var marks = Array.prototype.slice.call(root.querySelectorAll('.nx-scents__mark'));
    if (!track || cards.length < 2) return;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wide = window.matchMedia('(min-width: 990px)');
    var current = 0, timer = null, seen = false, held = false;
    var nearest = function () {
      var x = track.scrollLeft, best = 0, d = Infinity;
      cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - track.offsetLeft - x - parseFloat(getComputedStyle(track).scrollPaddingLeft || 0)); if (dd < d) { d = dd; best = i; } });
      return best;
    };
    var prev = root.querySelector('[data-nx-scents-prev]'), next = root.querySelector('[data-nx-scents-next]');
    var mark = function (i) {
      marks.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    };
    track.addEventListener('scroll', function () { current = nearest(); mark(current); }, { passive: true });
    var go = function (i) {
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft || 0);
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft - pad, behavior: 'smooth' });
    };
    var stop = function () { held = true; clearInterval(timer); timer = null; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { track.addEventListener(ev, stop, { passive: true }); });
    if (prev) prev.addEventListener('click', function () { stop(); go(Math.max(0, current - 1)); });
    if (next) next.addEventListener('click', function () { stop(); go(Math.min(cards.length - 1, current + 1)); });
    var hinted = false;
    var hint = function () {
      if (hinted || still || held || wide.matches || current !== 0) return;
      hinted = true;
      track.classList.add('is-hint');
      setTimeout(function () { track.classList.remove('is-hint'); }, 1300);
    };
    var run = function () {
      if (still || held || wide.matches || timer || !seen) return;
      timer = setInterval(function () { if (!seen) { clearInterval(timer); timer = null; return; } go((current + 1) % cards.length); }, 5000);
    };
    new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.intersectionRatio >= 0.5; if (seen) { hint(); run(); } }); }, { threshold: [0, 0.5, 1] }).observe(track);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-product-feature-grid"] && !Shopify.designMode) return;
  try {
    
  /* One delegated handler for every [data-nx-to-buy] on the page, whichever section printed it. */
  if (!window.__nxToBuy) {
    window.__nxToBuy = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nx-to-buy]');
      if (!b) return;
      var form = document.querySelector('.nx-product-hero__form');
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-product-film"] && !Shopify.designMode) return;
  try {
    
  /* Plays only while at least a third of it is on screen, and never for a reader who asked the system for less
     motion: they get the poster and the browser's own controls. preload="none" keeps it free until then. */
  (function () {
    var videos = document.querySelectorAll('[data-nx-film]');
    if (!videos.length) return;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    videos.forEach(function (v) {
      v.muted = true;
      if (still || !('IntersectionObserver' in window)) { v.controls = true; return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () { v.controls = true; }); }
          else v.pause();
        });
      }, { threshold: 0.33 }).observe(v);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-product-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nx-stories]').forEach(function (root) {
      if (root.__nx) return; root.__nx = true;
      var imgs = root.querySelectorAll('[data-nx-story-img]');
      var n = imgs.length; if (!n) return;
      var caps = root.querySelectorAll('[data-nx-story-cap]');
      var bars = root.querySelectorAll('[data-nx-story-bar]');
      var tracks = root.querySelectorAll('[data-nx-story-track]');
      var gos = root.querySelectorAll('[data-nx-story-go]');
      var pauseBtn = root.querySelector('[data-nx-story-pause]');
      var vids = {};
      root.querySelectorAll('[data-nx-story-vid]').forEach(function (v) {
        vids[v.getAttribute('data-nx-story-vid')] = v;
        v.addEventListener('playing', function () { v.classList.add('is-on'); });
      });
      var dur = (parseFloat(root.getAttribute('data-seconds')) || 4.5) * 1000;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, t = 0, paused = still, seen = false, last = 0;
      function paint() {
        imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        caps.forEach(function (el, k) { el.classList.toggle('is-on', k === i); });
        gos.forEach(function (el) { el.classList.toggle('is-on', Number(el.getAttribute('data-nx-story-go')) === i); });
        var p = Math.min(1, t / dur);
        bars.forEach(function (b, k) { b.style.width = (k < i ? 100 : k === i ? p * 100 : 0) + '%'; });
        tracks.forEach(function (b, k) { b.style.width = (k === i ? p * 100 : 0) + '%'; });
        var on = imgs[i], z = still ? '' : 'scale(' + (1 + 0.05 * p).toFixed(4) + ')';
        if (on) on.style.transform = z;
        if (vids[i]) vids[i].style.transform = z;
      }
      function syncVid() {
        Object.keys(vids).forEach(function (key) {
          var v = vids[key], k = Number(key);
          if (k === i && seen && !paused) {
            if (!v.getAttribute('src')) v.src = v.getAttribute('data-src');
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else if (!v.paused) v.pause();
          if (k !== i) { v.classList.remove('is-on'); if (v.readyState) v.currentTime = 0; }
        });
      }
      function go(k) { i = (k + n) % n; t = 0; paint(); syncVid(); }
      function frame(now) {
        var dt = last ? now - last : 0; last = now;
        if (!paused && seen) { t += dt; if (t >= dur) go(i + 1); else paint(); }
        requestAnimationFrame(frame);
      }
      gos.forEach(function (el) { el.addEventListener('click', function () { go(Number(el.getAttribute('data-nx-story-go'))); }); });
      var prev = root.querySelector('[data-nx-story-prev]'), next = root.querySelector('[data-nx-story-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      function setPaused(v) {
        paused = v; root.classList.toggle('is-paused', v);
        if (pauseBtn) pauseBtn.setAttribute('aria-label', v ? 'Play the steps' : 'Pause the steps');
        syncVid();
      }
      if (pauseBtn) pauseBtn.addEventListener('click', function () { setPaused(!paused); });
      setPaused(paused);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; }); syncVid(); }, { threshold: 0.35 }).observe(root);
      } else seen = true;
      paint();
      requestAnimationFrame(frame);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-trust"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nxToBuy) {
    window.__nxToBuy = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-nx-to-buy]');
      if (!b) return;
      var form = document.querySelector('.nx-product-hero__form');
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
